module.exports = "<div ui-view=\"rr-instrumentation-panel\"></div>\r\n<div ui-view=\"notification-panel\"></div>\r\n\r\n<div id=\"header-panel\" class=\"shop-header\">\r\n    <wow-header></wow-header>\r\n</div>\r\n\r\n<div id=\"content-container\" class=\"shop-content\" ui-view=\"content\"></div>\r\n\r\n<wow-footer></wow-footer>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/shop/views/shop.view.html
// module id = 1062
// module chunks = 0